export default {
  realm: process.env.VUE_APP_KEYCLOAK_REALM_NAME,
  url: process.env.VUE_APP_KEYCLOAK_AUTH_URL,
  clientId: process.env.VUE_APP_KEYCLOAK_AUTH_CLIENT
};
